import React,{useState} from 'react';
import {motion} from 'framer-motion';
import TemplateEditor from './TemplateEditor';
import MessagePreview from './MessagePreview';

const FeedbackTemplateApp=()=> {
  // Centralized state for the standardized form with signature and more note types
  const [formData,setFormData]=useState({
    student_name: '',
    topic: '',
    vocab_grammar: '',
    performance_level: 'really well', // default value
    performance_content: '',
    improvement_1: '',
    improvement_2: '',
    note_type: 'Homework Assignment', // default value
    note_content: '',
    signature_title: '',
    signature_name: ''
  });

  // State for the final edited message
  const [finalMessage,setFinalMessage]=useState('');

  const handleFormChange=(key,value)=> {
    setFormData(prev=> ({...prev,[key]: value}));
  };

  // Handle message updates from the preview
  const handleMessageUpdate=(updatedMessage)=> {
    setFinalMessage(updatedMessage);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      <div className="container mx-auto px-4 py-8 max-w-7xl">
        <motion.div
          initial={{opacity: 0,y: -20}}
          animate={{opacity: 1,y: 0}}
          className="text-center mb-8"
        >
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-4" style={{backgroundColor: '#4a8ccc'}}>
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          </div>
          <h1 className="text-4xl font-bold mb-2" style={{color: '#4a8ccc'}}>
            Lesson Feedback
          </h1>
          <p className="text-gray-600 text-lg">
            Speed up your workflow with one-click class reports
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Editor Column - 1/3 */}
          <motion.div
            initial={{opacity: 0,x: -20}}
            animate={{opacity: 1,x: 0}}
            transition={{delay: 0.1}}
            className="lg:col-span-1"
          >
            <TemplateEditor
              formData={formData}
              onChange={handleFormChange}
            />
          </motion.div>

          {/* Preview Column - 2/3 */}
          <motion.div
            initial={{opacity: 0,x: 20}}
            animate={{opacity: 1,x: 0}}
            transition={{delay: 0.2}}
            className="lg:col-span-2 lg:sticky lg:top-8 h-fit"
          >
            <MessagePreview
              formData={formData}
              onMessageUpdate={handleMessageUpdate}
              finalMessage={finalMessage}
            />
          </motion.div>
        </div>

        {/* Footer */}
        <motion.footer
          initial={{opacity: 0,y: 20}}
          animate={{opacity: 1,y: 0}}
          transition={{delay: 0.3}}
          className="mt-16 text-center pb-8"
        >
          <div className="text-gray-500 text-sm">
            Built with <span className="text-red-500">❤️</span> by{' '}
            <a 
              href="https://super-teacher.net" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="font-medium transition-colors"
              style={{color: '#4a8ccc'}}
            >
              SuperTeacher
            </a>
          </div>
        </motion.footer>
      </div>
    </div>
  );
};

export default FeedbackTemplateApp;